export const capitalizeFirstLetter = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

export function getUrlPart(url: string, position: number) {
  const parts = url.split('/');

  return parts.at(position);
}